import { getColleagueStore } from '../modules/colleagues';
import { CurrentUserStore, UserStore } from './User';

export const ColleaguesStore = getColleagueStore(CurrentUserStore, UserStore.getInstance());
